import React from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from './Modal';
import { useSubscription } from '../context/SubscriptionContext';

export default function UpgradeModal({ isOpen, onClose }) {
  const navigate = useNavigate();
  const { invoicesThisMonth, invoiceLimit } = useSubscription();

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Invoice Limit Reached" size="sm">
      <div className="text-center py-2">
        <div className="text-4xl mb-4">🚀</div>
        <p className="text-gray-700 mb-2">
          You've used <strong>{invoicesThisMonth}/{invoiceLimit}</strong> free invoices this month.
        </p>
        <p className="text-gray-500 text-sm mb-6">
          Upgrade to Pro for unlimited invoices, email sending, and auto reminders.
        </p>
        <button
          onClick={() => { onClose(); navigate('/pricing'); }}
          className="btn-primary w-full mb-3"
        >
          Upgrade to Pro — ₹499/month
        </button>
        <button onClick={onClose} className="btn-secondary w-full">
          Maybe Later
        </button>
      </div>
    </Modal>
  );
}
